import InitApi from "api/InitApi";
import useTokenStore from "store/tokenStore";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import ServerErrors from "components/SeverErrors";
import { getHost } from "utils";

const useSetOrderAsDelivered = (orderId) => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const submit = async () => {
		const instance = await InitApi({ accessToken });
		const orderUrl = getHost() + "/my-account/orders?search=" + orderId;
		const response = await instance.post(
			`/orders/set-as-delivered/${orderId}`,
			{
				orderUrl,
			}
		);
		await queryClient.invalidateQueries(["orders"]);
		return response?.data;
	};

	return useMutation(submit, {
		onSuccess: async (body) => {
			toast.success(body.message);
		},
		onError: async (error) => {
			<ServerErrors
				errorMessage={error?.response?.data.message}
				errors={error?.response?.data?.data}
			/>;
		},
	});
};

export default useSetOrderAsDelivered;
